import {
    NotSupportedCalendarText,
    NotSupportedCalendarsText,
} from './setNonSearchableCalendarsTextMutator.locstring.json';
import loc, { format } from 'owa-localize';
import getCalendarSearchStore from '../store/store';
import getSelectedCalendarsForUser from '../selectors/getSelectedCalendarsForUser';
import { mutator } from 'satcheljs';
import { setNonSearchableCalendarsText } from '../actions/searchStoreActions';
import { getUserConfiguration } from 'owa-session-store';
import {
    getCalendarEntryByFolderId,
    getCalendarFolderId,
    isLocalCalendarEntry,
} from 'owa-calendar-cache';
import { CalendarEntry } from 'owa-graph-schema';

export const setNonSearchableCalendarsTextMutator = mutator(
    setNonSearchableCalendarsText,
    actionMessage => {
        const searchStore = getCalendarSearchStore();
        if (!actionMessage.dismissNotification) {
            const selectedCalendars: CalendarEntry[] = getSelectedCalendarsForUser(
                searchStore.accountSmtpAddress ||
                    getUserConfiguration().SessionSettings.LogonEmailAddress
            );

            const nonSearchableCalendarNames: string[] = [];

            // Filter out the non-local calendars
            const calendarFolderIds = selectedCalendars
                .map(c => getCalendarFolderId(c))
                .filter(id => !isLocalCalendarEntry(id) && getCalendarEntryByFolderId(id));

            calendarFolderIds.forEach(folderId => {
                nonSearchableCalendarNames.push(getCalendarEntryByFolderId(folderId).CalendarName);
            });

            if (nonSearchableCalendarNames.length > 0) {
                searchStore.notSupportedNotification =
                    nonSearchableCalendarNames.length == 1
                        ? format(loc(NotSupportedCalendarText), nonSearchableCalendarNames[0])
                        : format(
                              loc(NotSupportedCalendarsText),
                              nonSearchableCalendarNames.join(', ')
                          );
            } else {
                searchStore.notSupportedNotification = null;
            }
        } else {
            searchStore.notSupportedNotification = null;
        }
    }
);
